import request from '@/utils/request'

export function login(data){
    return request({
        url: '/auth/login',
        method: 'post',
        data
      })
}
export function logout(params){
    return request({
        url: '/auth/logout',
        method: 'get',
        params
      })
}


// WEBPACK FOOTER //
// ./src/api/user.js